import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";

const LevelSelect = props => {
  const { groupLessonLevels } = props;
  const { selectedGroupLessonLevel } = props;
  const { handleGroupLessonLevelChange } = props;

  return (
    <select
      className="form-control"
      title="Select"
      name="group_lesson[group_lesson_level_id]"
      id="group_lesson_group_lesson_level_id"
      value={selectedGroupLessonLevel.id}
      onChange={handleGroupLessonLevelChange}
    >
      {groupLessonLevels.map((groupLessonLevel) =>
        <option
          key={groupLessonLevel.id}
          value={groupLessonLevel.id}
        >
          {groupLessonLevel.name}
        </option>
      )}
    </select>
  )
}

class ProgramLevelSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedGroupLessonProgram: _.first(this.props.groupLessonPrograms),
      selectedGroupLessonLevel: {}
    };

    this.handleGroupLessonProgramChange = this.handleGroupLessonProgramChange.bind(this);
    this.handleGroupLessonLevelChange = this.handleGroupLessonLevelChange.bind(this);
  }

  componentWillMount () {
    this.setInitialSelected();
  }

  handleGroupLessonProgramChange(event) {
    this.selectGroupLessonProgram(event.target.value);
  }

  handleGroupLessonLevelChange(event) {
    this.selectGroupLessonLevel(event.target.value);
  }

  getGroupLessonLevel(levelId, selectedGroupLessonProgram=null) {
    if(!selectedGroupLessonProgram)
      selectedGroupLessonProgram = this.state.selectedGroupLessonProgram

    var selectedGroupLessonLevel = selectedGroupLessonProgram.active_group_lesson_levels.find(
      (groupLessonLevel) => groupLessonLevel.id == levelId
    );

    if(!selectedGroupLessonLevel) {
      selectedGroupLessonLevel = _.first(selectedGroupLessonProgram.active_group_lesson_levels);
    }

    return selectedGroupLessonLevel || '';
  }

  selectGroupLessonProgram(programId) {
    if(!programId) return;

    var selectedGroupLessonProgram = this.props.groupLessonPrograms.find(
      (groupLessonProgram) => groupLessonProgram.id == programId
    );
    var selectedGroupLessonLevel = this.getGroupLessonLevel(this.props.selectedLevel, selectedGroupLessonProgram)

    this.setState({selectedGroupLessonProgram, selectedGroupLessonLevel});
  }

  selectGroupLessonLevel(levelId) {
    this.setState({selectedGroupLessonLevel: this.getGroupLessonLevel(levelId)});
  }

  setInitialSelected = () => {
    this.selectGroupLessonProgram(this.props.selectedProgram);
  }

  disableProgramSelect = () => {
    return this.props.editing && this.props.memberCount > 0
  }

  render() {
    return (
      <div>
        <label>Lesson Program *</label>
        <div className="form-group" data-tip="Program cannot be changed if Lesson has members">
          <select
            title="Select Program"
            value={this.state.selectedGroupLessonProgram.id}
            onChange={this.handleGroupLessonProgramChange}
            className="form-control"
            name="group_lesson_program_id"
            id="group_lesson_program_id"
            hide_label="true"
            disabled={this.disableProgramSelect()}
          >
            {this.props.groupLessonPrograms.map((groupLessonProgram) =>
              <option
                key={groupLessonProgram.id}
                value={groupLessonProgram.id}
              >
                {groupLessonProgram.name}
              </option>
            )}
          </select>
          {this.disableProgramSelect() && <ReactTooltip />}
        </div>
        <label>Lesson Level *</label>
        <div className="form-group">
          <LevelSelect
            groupLessonLevels={this.state.selectedGroupLessonProgram.active_group_lesson_levels}
            selectedGroupLessonLevel={this.state.selectedGroupLessonLevel}
            handleGroupLessonLevelChange={this.handleGroupLessonLevelChange}
          />
        </div>
      </div>
    );
  }
}

ProgramLevelSelect.propTypes = {
  groupLessonPrograms: PropTypes.array,
  selectedProgram: PropTypes.number,
  selectedLevel: PropTypes.number
};

export default ProgramLevelSelect;
